import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FW_PREFIX } from '../../shared/constants/generalConstants.js';

var IlCard = /*#__PURE__*/function (_Component) {
  function IlCard() {
    _classCallCheck(this, IlCard);
    return _callSuper(this, IlCard, arguments);
  }
  _inherits(IlCard, _Component);
  return _createClass(IlCard, [{
    key: "renderTitleSection",
    value: function renderTitleSection() {
      var _this$props = this.props,
        title = _this$props.title,
        descriptionText = _this$props.descriptionText;
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames("".concat(FW_PREFIX, "__IlCard__title__container"))
      }, /*#__PURE__*/React__default.createElement("h1", {
        className: classNames("".concat(FW_PREFIX, "__IlCard__title"))
      }, title), /*#__PURE__*/React__default.createElement("p", {
        className: classNames("".concat(FW_PREFIX, "__IlCard__description_text"))
      }, descriptionText));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        title = _this$props2.title,
        children = _this$props2.children,
        className = _this$props2.className;
      return /*#__PURE__*/React__default.createElement("section", {
        className: classNames("".concat(FW_PREFIX, "__IlCard"), className)
      }, title && this.renderTitleSection(), /*#__PURE__*/React__default.createElement("div", null, children));
    }
  }]);
}(Component);
IlCard.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  descriptionText: PropTypes.node,
  children: PropTypes.node
};

export { IlCard };
